/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { ok, err, readFromStart, noStreams };
function ok(o) {
    return !(o && typeof o === "object" && "$error" in o);
}
function err($error) {
    return { $error };
}
function readFromStart(path, data, start) {
    if (!data) {
        return err(`File at "${path}" is empty`);
    }
    if (start >= data.length) {
        return err(`Length of file is lesser than start "${start}"`);
    }
    return {
        data: data.slice(start),
        last: data.length - 1,
    };
}
function noStreams(done, receipt) {
    if (done || receipt) {
        return err("Can't close the file that isn't a stream");
    }
}
//# sourceMappingURL=utils.js.map